import libUrlJoin from 'url-join';
import { config } from '@packages/shared/config';
import { AnchorHref } from '../entities';

export function joinUrls(...args: Array<string>) {
  return libUrlJoin(args);
}

export function withDefaultOrigin(...args: Array<string>) {
  return joinUrls(config.appOrigin.default, ...args);
}

export function withMainAppOrigin(...args: Array<string>) {
  return joinUrls(config.appOrigin.mainApp, ...args);
}

export function withAsknebulaOrigin(...args: Array<string>) {
  return joinUrls(config.appOrigin.asknebula, ...args);
}

export function withGuidanceOrigin(...args: Array<string>) {
  return joinUrls(config.appOrigin.guidance, ...args);
}

export function withBirthchartsOrigin(...args: Array<string>) {
  return joinUrls(config.appOrigin.birthcharts, ...args);
}

export const getUrlPortionAfterLastSlash = (url: string) => url.split('/').pop();
export const getUrlWithoutFirstSlash = (url: string) => url.replace(/^\/(.*)$/, '$1');

export const createIdAnchor = <T extends string>(id: T): AnchorHref<T> => `#${id}`;
export const createMailToHref = (email: string) => `mailto:${email}` as const;
